import { Link } from "react-router-dom";
import Layout from "../../../components/global/layout";
import "./profile.scss";
import methodModel from "../../../methods/methods";
import { useSelector } from "react-redux";
import { MdOutlineMailOutline } from "react-icons/md";
import { BiUser } from "react-icons/bi";
import { HiOutlinePhone } from "react-icons/hi";


const Profile = () => {
  const user = useSelector((state: any) => state.user);

  return (
    <Layout>
      <div className="wrapper_section">
        <div className="flex items-center  justify-between">
          <h3 className=" text-lg lg:text-2xl font-semibold text-[#111827]">
            Profile Information
          </h3>

        </div>

        <div className="inner_part sm:mt-3 md:mt-8 bg-white rounded-lg   p-4  ">
          <div className="grid items-center grid-cols-1 gap-4 mb-5">
            <div className="w-full max-w-xl mx-auto">
              <div className="p-6 rounded-2xl shadow bg-gray-50 border border-gray-100">

                {/* Profile Image */}
                <div className="flex flex-col items-center gap-4 mb-8">
                  <img
                    src={methodModel.userImg(user?.image)}
                    className="h-32 w-32 rounded-full object-cover border-4 border-primary shadow-md"
                    alt="Profile"
                  />
                  <p className="text-lg font-semibold text-gray-800 capitalize">
                    {user?.fullName || "--"}
                  </p>
                </div>

                {/* User Info */}
                <div className="flex flex-col gap-4">
                  {/* Full Name */}
                  <div className="flex items-center justify-between bg-gray-50 p-3 rounded-lg shadow-sm">
                    <div>
                      <label className="text-gray-500 text-sm font-medium">Full Name</label>
                      <p className="text-gray-800 text-sm capitalize">{user?.fullName}</p>
                    </div>
                    <div className="bg-primary/10 text-primary p-2 rounded-full">
                      <BiUser className="text-lg" />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="flex items-center justify-between bg-gray-50 p-3 rounded-lg shadow-sm">
                    <div>
                      <label className="text-gray-500 text-sm font-medium">Email</label>
                      <p className="text-gray-800 text-sm break-all">{user?.email}</p>
                    </div>
                    <div className="bg-primary/10 text-primary p-2 rounded-full">
                      <MdOutlineMailOutline className="text-lg" />
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex items-center justify-between bg-gray-50 p-3 rounded-lg shadow-sm">
                    <div>
                      <label className="text-gray-500 text-sm font-medium">Phone Number</label>
                      <p className="text-gray-800 text-sm">
                        {!user?.mobileNo ? '--' : `+${user?.dialCode + user?.mobileNo}`}
                      </p>
                    </div>
                    <div className="bg-primary/10 text-primary p-2 rounded-full">
                      <HiOutlinePhone className="text-lg" />
                    </div>
                  </div>
                </div>

                {/* Edit Profile Button */}
                <Link
                  to="/profile/edit"
                  className="mt-6 w-full inline-flex items-center justify-center gap-2 text-sm font-medium bg-primary text-white h-10 rounded-lg shadow hover:opacity-90 transition-all focus:ring-2 ring-offset-2 ring-primary"
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
                  </svg>
                  Edit Profile
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
